import FormInput from './FormInput';
import AudioPreview from './AudioPreview';
import PropTypes from 'prop-types'
import { useState } from 'react';
import { useOptions } from '../hooks/useOptions';

// Which reciter, and a sample of them.
//
// There is no on/off switch here any more. Starting and stopping the recitation
// is the one thing wanted daily, so it lives on the home screen; leaving a
// second control for the same setting in here would mean two places to look and
// two to keep in step.
//
// The list also used to be hidden behind that switch, so turning recitation off
// took away the only way to choose who recites -- and after the home screen took
// over the switching, the panel was empty whenever it was off. Choosing a
// reciter is not conditional on recitation being on right now.
const SettingQuran = ( {DeviceKey, DeviceSetting, onSettingChange } ) => {

    const [quranSound, setQuranSound] = useState(`${import.meta.env.REACT_APP_AUDIO_URL}/${DeviceSetting['quran-sound']}/002185.mp3`);
    const { list: reciterList } = useOptions(DeviceKey, 'reciter_list');

    const setSetting = (changedSettings) => {
        var tempSettings = [{...DeviceSetting}];

        changedSettings.forEach(({setting, value}) => {
            try {
                tempSettings[0][setting] = value;
            } catch (error) {
                console.log('ERROR: getSetting', setting, DeviceSetting, value, error);
            }
        });
        onSettingChange( tempSettings );
    }

    const onReciterChange = (e) => {
        const quranSample = `${import.meta.env.REACT_APP_AUDIO_URL}/${e}/002185.mp3`;

        setSetting( [{setting: 'quran-sound', value: `${e}`}] );

        setQuranSound( quranSample );
    }

    return (
        <>
            <FormInput name="quran-sound"
                    labelText="Reciter"
                    inputType="select"
                    value={DeviceSetting['quran-sound']}
                    options={reciterList}
                    maxLen={40}
                    onValueChange={onReciterChange} />

            <AudioPreview src={quranSound} />

            <p className="hint">
                Recitation plays between prayers. Start and stop it from the home screen.
            </p>
        </>
    );
}

SettingQuran.propTypes = {
    DeviceKey: PropTypes.string,
    DeviceSetting: PropTypes.object.isRequired,
    onSettingChange: PropTypes.func.isRequired,
}

export default SettingQuran
